import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  tickets: [],
  countUnreadMessages: 0,

  ticketTopics: [],
  createdTicketStatus: '',

  ticket: {},
  dialog: [],
  addMessageStatus: '',
};

export const supportSlice = createSlice({
  name: 'support',
  initialState,
  reducers: {
    setTickets: (state, action) => {
      state.tickets = action.payload;
    },
    setCountUnreadMessages: (state, action) => {
      state.countUnreadMessages = action.payload;
    },

    setTicketTopics: (state, action) => {
      state.ticketTopics = action.payload;
    },
    setCreatedTicketStatus: (state, action) => {
      state.createdTicketStatus = action.payload;
    },

    setTicket: (state, action) => {
      state.ticket = action.payload;
    },
    setDialog: (state, action) => {
      state.dialog = action.payload;
    },
    setAddMessageStatus: (state, action) => {
      state.addMessageStatus = action.payload;
    },

    resetSupport: () => initialState,
  },
});

export const {
  setTickets,
  setCountUnreadMessages,

  setTicketTopics,
  setCreatedTicketStatus,

  setTicket,
  setDialog,
  setAddMessageStatus,

  resetSupport,
} = supportSlice.actions;

export default supportSlice.reducer;
